export type ConsentEvent = CustomEvent<{ data: string[] }>;

type HandleConsent = (event: ConsentEvent) => boolean | void;

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface Tag<S extends string> {
  readonly __tag: S;
}

export type PersonalisierungConsent = boolean & Tag<"Personalisierung">;
export type RichRelevanceConsent = boolean & Tag<"RichRelevance">;

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    ebConsentQueue?: HandleConsent[];
  }
}

export default class RecoConsent {
  private static RICH_RELEVANCE_SESSION_STORAGE_KEY: "entd_frontend_recommendation_consent" =
    "entd_frontend_recommendation_consent" as const;
  private static RICH_RELEVANCE_KEY: "RICHR" = "RICHR" as const;
  private static PERSONALISIERUNG_SESSION_STORAGE_KEY: "reco_frontend_recommendation_perso_consent" =
    "reco_frontend_recommendation_perso_consent" as const;
  private static PERSONALISIERUNG_KEY: "PERSO" = "PERSO" as const;

  static setupQueue(): void {
    if (typeof window !== "undefined") {
      window.ebConsentQueue = window.ebConsentQueue || [];
      window.ebConsentQueue.push(RecoConsent.handleConsentEvent);
    }
  }

  static getRichRelevanceConsent(): RichRelevanceConsent {
    try {
      return !!sessionStorage.getItem(
        RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
      ) as RichRelevanceConsent;
    } catch (_) {
      return false as RichRelevanceConsent;
    }
  }

  static getPersonalisierungConsent(): PersonalisierungConsent {
    try {
      return !!sessionStorage.getItem(
        RecoConsent.PERSONALISIERUNG_SESSION_STORAGE_KEY,
      ) as PersonalisierungConsent;
    } catch (_) {
      return false as PersonalisierungConsent;
    }
  }

  private static storeConsentInSessionStorage(
    key:
      | typeof RecoConsent.PERSONALISIERUNG_SESSION_STORAGE_KEY
      | typeof RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
  ): void {
    try {
      sessionStorage.setItem(key, "true");
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }

  private static removeConsentFromSessionStorage(
    key:
      | typeof RecoConsent.PERSONALISIERUNG_SESSION_STORAGE_KEY
      | typeof RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
  ): void {
    try {
      sessionStorage.removeItem(key);
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }

  private static handleConsentEvent(event: ConsentEvent): void {
    if (event.detail.data.includes(RecoConsent.RICH_RELEVANCE_KEY)) {
      RecoConsent.storeConsentInSessionStorage(
        RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
      );
    } else {
      RecoConsent.removeConsentFromSessionStorage(
        RecoConsent.RICH_RELEVANCE_SESSION_STORAGE_KEY,
      );
    }
    if (event.detail.data.includes(RecoConsent.PERSONALISIERUNG_KEY)) {
      RecoConsent.storeConsentInSessionStorage(
        RecoConsent.PERSONALISIERUNG_SESSION_STORAGE_KEY,
      );
    } else {
      RecoConsent.removeConsentFromSessionStorage(
        RecoConsent.PERSONALISIERUNG_SESSION_STORAGE_KEY,
      );
    }
  }
}
